var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const getErrorMessage = (result) => {
  var _a;
  if (200 !== result.statusCode) {
    return (_a = result.errorContext) == null ? void 0 : _a.displayError;
  } else {
    return "";
  }
};
const apiVersion = "2024-04-01-preview";
let ComputeResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.cms);
  }
  putCompute(workspaceId, postParams) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/compute-resources/${postParams.id}?api-version=${apiVersion}`;
      const result = yield this._put(postParams, address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  getCompute(workspaceId, id) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/compute-resources/${id}?api-version=${apiVersion}`;
      const result = yield this._get(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  getComputeList(workspaceId, id) {
    return __async(this, null, function* () {
      const filter = id ? `&$filter=CONTAINS(id,${id})` : "";
      const address = `/workspaces/${workspaceId}/compute-resources?api-version=${apiVersion}${filter}`;
      const result = yield this._get(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  deleteCompute(workspaceId, id) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/compute-resources/${id}?api-version=${apiVersion}`;
      const result = yield this._delete(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
};
ComputeResource = __decorateClass([
  WPSProxyConverter()
], ComputeResource);
const UnifiedComputeResource = new ComputeResource();
export {
  UnifiedComputeResource as default
};
//# sourceMappingURL=UnifiedCompute.resource.js.map
